<template>
	<tr>
		<td>{{row.NOMBRE}}</td>
		<td>{{row.phone}}</td>
		<td>{{row.activity}}</td>
		<td>{{row.OCUPADO}}</td>
	</tr>
</template>

<script>
	export default {
		name: "Row",
		props: ["row"],
	}
	
</script>

<style scoped>

</style>